import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./BestSellingSection.css";

const sections = [
  {
    title: "Best Selling Sex Toys for Men in India",
    viewAll: "/men",
    description:
      "Explore best selling sex toys for men in India with discreet delivery and premium quality.",
    products: [
      { id: 1, img: "/image/ForMen/ForMen1.jpg", name: "Jumbo Cup Masturbator", price: 1699, old: 1999 },
      { id: 2, img: "/image/ForMen/ForMen19.jpg", name: "Single Vibrating Cup", price: 3299, old: 6999 },
      { id: 3, img: "/image/ForMen/ForMen3.jpg", name: "Pocket Pussy", price: 1599, old: 1899 },
      { id: 4, img: "/image/ForMen/ForMen4.jpg", name: "Mia Cup Masturbator", price: 2199, old: 2599 },
      { id: 5, img: "/image/ForMen/ForMen20.jpg", name: "7 Mode Vibrating Cup", price: 3999, old: 4299 },
      { id: 6, img: "/image/ForMen/ForMen21.jpg", name: "Vibrating Masturbation Machine for Men – Powerful Modes & Discreet Delivery", price: 9999, old: 1299 },
      { id: 7, img: "/image/ForMen/ForMen23.jpg", name: "Vibrating Ring for Men – Adjustable Fit, Powerful Vibration & Discreet Delivery", price: 999, old: 1999 },
    ],
  },
  {
    title: "Best Selling Sex Toys for Women in India",
    viewAll: "/women",
    description:
      "Shop best selling sex toys for women in India including dildo, vibrator & pleasure toys.",
    products: [
      { id: 101, img: "/image/ForWomen/ForWomen1.jpg", name: "Dildo", price: 2500, old: 7999 },
      { id: 102, img: "/image/ForWomen/ForWomen2.jpg", name: "Realistic Dildo", price: 2999, old: 6999 },
      { id: 103, img: "/image/ForWomen/ForWomen3.jpg", name: "Butt Plug", price: 2999, old: 4999 },
      { id: 104, img: "/image/ForWomen/ForWomen4.jpg", name: "Belt Dildo", price: 3299, old: 4599 },
      { id: 105, img: "/image/ForWomen/ForWomen5.jpg", name: "Automatic Vibrating Dildo", price: 8999, old: 9599 },
      { id: 106, img: "/image/ForWomen/ForWomen9.jpg", name: "Vibrating Dildo", price: 2899, old: 4599 },
      { id: 107, img: "/image/ForWomen/ForWomen11.jpg", name: "G-Spot Mini Rabbit Vibrator – Dual Stimulation, Compact Design & Discreet Delivery", price: 5999, old: 6599 },
    ],
  },
  {
    title: "Best Selling Sex Toys for Couples in India",
    viewAll: "/couples",
    description:
      "Discover best selling sex toys for couples in India to enhance intimacy & pleasure.",
    products: [
      { id: 201, img: "/image/ForCouples/ForCouples1.jpg", name: "Handcuff Set", price: 2999, old: 4999 },
      { id: 202, img: "/image/ForCouples/ForCouples2.jpg", name: "Bedroom Kit", price: 3299, old: 4999 },
      { id: 203, img: "/image/ForCouples/ForCouples4.jpg", name: "Belt Condom", price: 2499, old: 3499 },
      { id: 204, img: "/image/ForCouples/ForCouples7.jpg", name: "Condom", price: 1300, old: 2399 },
      { id: 205, img: "/image/ForCouples/ForCouples5.jpg", name: "Couple Belt Condom", price: 2700, old: 3999 },
    ],
  },
];

const BestSellingSection = () => {
  return (
    <section
      className="best-wrapper"
      aria-label="Best Selling Sex Toys Online in India"
    >
      {/* 🔥 MAIN SEO H1 (ONLY ONCE PER PAGE) */}
      <h1 className="sr-only">
        Buy Best Selling Sex Toys Online in India | LushDesire
      </h1>

      {sections.map((sec, i) => (
        <Slider key={i} section={sec} />
      ))}
    </section>
  );
};

const Slider = ({ section }) => {
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.innerWidth < 768) return;

    const slider = sliderRef.current;
    let scroll = 0;

    const interval = setInterval(() => {
      scroll += slider.offsetWidth / 4;
      if (scroll >= slider.scrollWidth / 2) scroll = 0;
      slider.scrollTo({ left: scroll, behavior: "smooth" });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <article className="section">
      {/* ✅ H2 – CATEGORY TITLE */}
      <h2 className="section-title">{section.title}</h2>

      {/* ✅ H3 – CATEGORY DESCRIPTION (SEO BOOST) */}
      <h3 className="section-desc">{section.description}</h3>

      <div className="slider" ref={sliderRef}>
        {[...section.products, ...section.products].map((p, index) => (
          <div className="card" key={`${p.id}-${index}`}>

            <img
              src={p.img}
              alt={`${p.name} - buy sex toys online in India`}
              loading="lazy"
            />

            {/* ✅ PRODUCT NAME AS H4 (SEO SAFE) */}
            <h4 className="product-name">{p.name}</h4>

            <p className="price">
              ₹{p.price} <span>₹{p.old}</span>
            </p>

            {/* ✅ PRODUCT CTA */}
            <button
              type="button"
              className="order-btn"
              onClick={() =>
                navigate(`/product/${p.id}`, {
                  state: {
                    id: String(p.id),
                    name: p.name,
                    image: p.img,
                    price: p.price,
                    mrp: p.old,
                    description:
                      `${p.name} is a premium quality sex toy available in India with discreet delivery.`,
                  },
                })
              }
              aria-label={`Order ${p.name} online in India`}
            >
              Order Now
            </button>
          </div>
        ))}
      </div>

      <div className="viewall-wrap">
        <button
          className="view-all"
          onClick={() => navigate(section.viewAll)}
          aria-label={`View all ${section.title}`}
        >
          View All
        </button>
      </div>
    </article>
  );
};

export default BestSellingSection;
